import { sortBy } from 'lodash';
import qs from 'qs';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import client from './rest/AdminClient';

export const getMarkets = (query = {}) => {
  const mappedQuery = qs.stringify(query);
  return client({
    method: 'GET',
    path: `/api/1/markets?${mappedQuery}`,
  });
};

export const getAllMarkets = async (query) => {
  const response = await getMarkets(query);
  return sortBy(response.entity.markets, 'name');
};

export const normalizeMarketIds = (markets) =>
  (markets ?? [])
    .map((m) => (typeof m === 'string' ? m : m?._id))
    .filter(Boolean);

export const buildMarketMenuItems = (allMarkets, selectedMarketIds) =>
  (allMarkets ?? []).map((market) => ({
    ...market,
    selected: (selectedMarketIds ?? []).includes(market._id),
  }));
const createMarket = (market) =>
  client({
    method: 'POST',
    path: '/api/1/markets',
    entity: JSON.stringify(market),
  });

const updateMarket = (id, updates) =>
  client({
    method: 'PUT',
    path: `/api/1/markets/${id}`,
    entity: JSON.stringify(updates),
  });

export default {
  getMarkets(query) {
    getMarkets(query).then(
      (response) => {
        const markets = sortBy(response.entity.markets, 'name');
        AdminServerActionCreators.receiveMarkets(markets);
      },
      (response) => {
        console.error(response);
        // @TODO Handle failure
      },
    );
  },
  updateMarket(id, market) {
    updateMarket(id, market).then(
      (response) => {
        AdminServerActionCreators.updateMarketSuccess(response.entity.market);
      },
      (error) => {
        AdminServerActionCreators.updateMarketFail(error);
      },
    );
  },
  createMarket(market) {
    createMarket(market).then(
      (response) => {
        AdminServerActionCreators.createMarketSuccess(response.entity.market);
      },
      (error) => {
        AdminServerActionCreators.updateMarketFail(error);
      },
    );
  },
};
